var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('HeaderNav'),_c('v-main',{staticClass:"mt-4"},[(_vm.$route.path === '/')?_c('router-view'):_c('v-container',[_c('router-view')],1)],1),_c('NewsLetter'),_c('FooterNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }